import * as mulitplesAPI from "app/api/multiplesBetsApi";
import store from "app/store/store";
import { BetSlipType } from "app/types/betSlipType";
import { BetSlipHelper } from "./betSlipHelper";

export class MultiplesHelper {
  static isMultipleSet(runnerId: number): any | boolean {
    let multipleFound = false;
    const multiplesBetSlipList =
      store.getState().multiplesBetSlipListModel.multiplesBetSlipList;

    multiplesBetSlipList.forEach(multiplesBetSlip => {
      if (multiplesBetSlip["runnerId"] === runnerId) {
        multipleFound = true;
      }
    });

    return multipleFound;
  }

  static decreaseNumberOfMultiplesNotAvailable = async (
    betAdded: BetSlipType
  ) => {
    const marketId = BetSlipHelper.getBetSlipMarket(betAdded)?.id;
    // if multiple bets enabled for this bet.
    // Add corresponding multiple bet to multiple betslip panel
    if (marketId) {
      mulitplesAPI
        .isMarketEnabled(marketId)
        .then(
          resp =>
            resp.data === false &&
            store.dispatch.betSlipListModel.decreaseNumberOfMultiplesNotAvailable()
        );
    }
  };

  // check if multiple bets is enabled for new added bet
  static checkIfMultiplesEnabled = async (betAdded: BetSlipType) => {
    const marketId = BetSlipHelper.getBetSlipMarket(betAdded)?.id;
    // if multiple bets enabled for this bet.
    // Add corresponding multiple bet to multiple betslip panel
    if (marketId) {
      mulitplesAPI.isMarketEnabled(marketId).then(resp => {
        if (resp.data) {
          this.addToMultiples(betAdded);
        } else {
          store.dispatch.betSlipListModel.increaseNumberOfMultiplesNotAvailable();
        }
      });
    }
  };
  // test commit

  // add corresponding multiple bet to multiple bets panel
  static addToMultiples = betAdded => {
    const user = store.getState().userModel.user;
    const betSlipMarket = BetSlipHelper.getBetSlipMarket(betAdded);
    const runner = betSlipMarket?.runners[0];
    const odds =
      runner &&
      BetSlipHelper.getBetSlipOddFromPrice(
        runner["aggregatedPrices"][0],
        user.preferences?.priceViewMode
      );

    // add multiple bet to multiple bets store
    if (runner && odds) {
      const { translatedSportName, translatedName, markets, sportType, id } =
        betAdded;
      const marketName = betSlipMarket.name;
      const marketType = betSlipMarket.marketInternalType;
      const marketPeriod = markets[0].period;
      const runnerId = runner.id;
      const oddsType = runner?.["aggregatedPrices"][0]?.oddsType;

      store.dispatch.multiplesBetSlipListModel.addMultiplesBetSlip({
        translatedSportName,
        translatedName,
        runnerId,
        runner,
        marketName,
        marketType,
        marketPeriod,
        sportType,
        odds,
        submittedType: "BET",
        order: false,
        message: "",
        instantResponse: false,
        eventId: id,
        oddsType: oddsType,
      });
    }
  };

  static removeCorrespondingSingleBets = () => {
    const multiplesBetSlipList =
      store.getState().multiplesBetSlipListModel.multiplesBetSlipList;
    const runnerIds = multiplesBetSlipList.map(m => m.runnerId);
    this.removeCorrespondingSingleBet(runnerIds);
  };

  // if multiple bet removed from multiple betslip panel
  // remove corresponding single bet from single betslip panel
  static removeCorrespondingSingleBet = (runnerIds: number[]) => {
    const betSlipList = store.getState().betSlipListModel.betSlipList;
    // cycle through list of multiple bets being remove
    // and remove corresponding single bets from betslip panel
    runnerIds.forEach(runnerId => {
      // get localID for corresponding single bet to be removed
      const correspondingBetSlip = betSlipList.find(
        betSlip => betSlip.markets[0].runners[0].id === runnerId
      );
      // remove single bet from betslip panel
      if (correspondingBetSlip) {
        store.dispatch.betSlipListModel.removeBetSlip(
          correspondingBetSlip.localId
        );
      }
    });
  };
}
